import { render } from "./NewExpense.vue?vue&type=template&id=08b17df4"
import script from "./NewExpense.vue?vue&type=script&lang=js"
export * from "./NewExpense.vue?vue&type=script&lang=js"
script.render = render

export default script